const onboarding = {
  // A
  action: 'اجراء',
  add: 'إضافة',
  activate_offline: 'إختيار',
  add_all: 'إضافة الجميع',
  adding_new_departments_helper: 'اضافة الادارات و الاقسام',
  area: 'المنطقة',
  ajeer_onboarding: 'موظف أجير',
  address: 'العنوان',
  adjust_your_logo: 'حدد حجم الشعار المناسب',
  add_iban: 'إضافة رقم الحساب المصرفي (IBAN)',
  edit_iban: 'تعديل رقم الحساب المصرفي (IBAN)',
  add_new_allowance: 'إضافة بدل جديد',
  add_new_contract_type: 'إضافة نوع عقد جديد',
  add_business_unit: 'اضف وحدات العمل',
  add_business_units_savola_groups: 'إضافة قسم جديد لـ {{groups_name}}',
  add_new_custom_leave_onboarding: 'Add new custom leave_AR',
  Add_departments_to_Savola_Groups: 'إضافة إدارة و أقسام جديدة لـ {{groups_name}}',
  add_all_mentioned_above: 'أضف جميع المسميات المحددة أعلاة',
  add_new_work_location: ' Add New Work LocationAR',
  a_unique_name_linked_to_our_main_domain_jisr_description:
    ' يمثل العنوان الخاص بك في منصة {{app_name}} ،وهو عنوان مميز وفريد وغير مكرر لكل موقع بالتالي الاسم الذي ستختارة سيضاف لاسم النطاق الخاص ب{{app_name}} حتي يمكنك و كل موظفينك الدخول للنظام هذا الاسم يجب ان يكون بالاحرف الانجليزية و لا يفضل استخدام فيه الارقام او الرموز ولا المسافات و يفضل ان تختار اسم قصير يعبر عن اسم مؤسستك مثل مؤسسة {{app_name}} اسم النطاق الخاص بها هو {{app}}',
  an_organisation_desc: 'الكيان الرئيسي للمنشاة التي تستخدم النظام، وقد تتضمن منشأت فرعية تابعة',
  annual_leave_entitlement_onboarding: 'الإجازة السنوية المستحقة',
  annual_leave_auto_upgrade: 'الزيادة التلقائية للاستحقاق السنوي',
  annual_leave_auto_upgrade_description:
    'بعد اتمام الموظف ٥ سنوات من العمل في منشأتك، سيزاد رصيده السنوي للقيمة المعرفة أدناه تلقائيًا. ولن يتغير الرصيد إذا كان رصيد الموظف اعلى من هذا الرقم',
  account_setup: 'تهيئة الحساب',
  attendance_setup: 'إعداد الحضور',
  add_holidays_leave: 'إضافة عيد رسمي',
  annual_leave_policies: 'سياسات الإجازة السنوية',
  annual_leave_onboarding: 'الإجازة السنوية',
  annual_leave_settings: 'احتساب الإجازة السنوية ',
  annual_leave_settings_description:
    'عند تحديد طريقة احتساب أيام الإجازة (أيام عمل أو تقويم)، ستختلف آلية خصم رصيد إجازات الموظفين. يمكنك اختيار الطريقة المناسبة لاحتساب الإجازات.',
  annual_leave_entitlement_onboarding_description:
    'عند تحديد عدد أيام الإجازة السنوية للموظفين، ستتمكن من اختيار الرصيد المستحق لكل موظف لاحقاً',
  accumulative_balance: 'الرصيد التراكمي',
  accumulative_balance_description:
    'سيزداد الرصيد السنوي بشكل يومي لكل موظف بناء على استحقاقه السنوي.',
  accumulative_balance_description_tip:
    'مثال: إذا كان الأستحقاق السنوي للموظف 30 يوم. و أمضى ثلاثة اشهر على رأس العمل فسيستحق رصيد قدرة 7.5 يوم',
  add_custom_leave: 'إضافة اجازة مخصصة',
  allowances_onboarding: 'قائمة البدلات',
  allowances_desc:
    'يمكنك تخصيص البدلات الأخرى التي تقدمها للموظفين لتضاف إلى الراتب الأساسي في كل شهر',
  allowances_list: 'البدلات',
  allowance_name_en: 'اسم البدل (إنجليزي)',
  type_allowance_name: 'أكتب اسم البدل',
  allowance_name_ar: ' اسم البدل (عربي)',
  authorize_payment_admins: 'تفويض المسئولين عن عملية الدفع',
  authorized_person_desc: 'الاشخاص المفوضين بإمكانهم صرف الرواتب عن طريق مدد',
  admin_users: 'مشرف المنشأة ',
  add_admins_onb: 'إضافة مشرفين',
  Make_sure_that_have_admin:
    'لإضافة مشرفين للنظام في هذة الخطوة، فقط تاكد انك اضفت البريد الإليكتروني الخاص بهم بشكل صحيح في خطوة بيانات الموظفين',
  admin_users_desc:
    'حدد المستخدمين الذين تريد منحهم صلاحية المشرف لحساب {{app_name}}، سيتمكن المشرف من الوصول لكل معلومات الموظفين والتحكم بإعدادات النظام.',
  add_only_the_admins:
    'بهذة الخطوة يتم دعوة مسؤلين النظام (أدمن)، ما تبقي من الموظفين سيتم دعوتهم عند الانتهاء من تهيئة إعدادات النظام',
  new_leave: 'إجازة جديدة',
  add_new_location: 'إضافة موقع جديد',
  // B
  bank_account_desc: 'سيتم صرف الرواتب من البنك المحدد',
  based_on_your_industry_type:
    'بناء على قطاع أو مجال المنشأة، سيقترح نظام {{app_name}} تلقائيًا مجموعة من المسميات الوظيفية. يمكنك إضافتها أو إضافة بعضها، كما يمكنك أيضًا إضافة مسميات وظيفية جديدة.',
  all_basic_information_for_your_organization_is_saved:
    'جميع معلومات المنشأة الأساسية مدخلة، يمكنك البدء باستخدام {{app_name}} بهذا القدر من المعلومات',
  // B
  browse_computer: 'تصفح الكمبيوتر',
  add_business_units: 'إضافة وحدات العمل',
  business_units_discription: 'وحدات العمل ',
  based_on_your_industry_desc:
    'بناء على قطاع أو مجال المنشأة، سيقترح نظام {{app_name}} تلقائيًا مجموعة من المسميات الوظيفية. يمكنك إضافتها أو إضافة بعضها، كما يمكنك أيضًا إضافة مسميات وظيفية جديدة.',
  benefits_in_kind:
    'Benefits in kind (also called fringe benefits or perks) include various types of non-wage compensation provided to employees in addition to their normal wages or salaries.AR',
  brand_name_en: 'العلامة التجارية (بالإنجليزية)',
  brand_name_ar: 'العلامة التجارية (بالعربية)',
  bulk_update: 'تعديل دفعة واحدة',
  business_days: 'أيام عمل',
  business_days_discription:
    'احتساب أيام العمل من الإجازة فقط.  مثال: اذا تقدّم الموظف بطلب إجازة من تاريخ ١ أكتوبر إلى ٧ أكتوبر، يخصم من رصيده ٥ أيام فقط لوجود يوميّ اجازة نهاية اسبوع خلال تلك الفترة',
  onboarding_brand_name: 'اسم العلامة التجارية',
  // C
  cancel: 'إلغاء',
  carry_forward_balance: 'الرصيد المرحل من السنة السابقة',
  city: 'المدينة',
  country: 'الدولة',
  continue: 'استمرار',
  check_Availability: 'تأكد من توافر النطاق',
  checking_subdomain_availability: 'جاري التأكد من توافر النطاق',
  cr_number: 'رقم السجل التجاري  ',
  copmany_logo_desc:
    'سيظهر شعار المنشأة في واجهة استخدام نظام {{app_name}} وكذلك في تطبيق الخدمة الذاتية. تأكد من رفع الشعار بصيغة JPEG أو PNG. الرجاء التاكد من حجم الشعار بحيث لا يتجاوز 2MB',
  org_name: 'اسم المنشأة',
  commercial_registration_details:
    'لكل منشأة تجارية (مؤسسة فردية، شركة .. إلخ) يعمل بها الموظفين سجل تجاري واحد على الاقل، بالإضافة إلى رقم ملف موحد في مكتب العمل، وإشتراك في المؤسسة العامة للتأمينات الإجتماعية. ولذا يلزم تعريف وإضافة هذه البيانات على نظام {{app_name}}، من أجل التوافق مع متطلبات برنامج حماية الأجور، فإذا كان لديك اي سجل تجاري غير مربوط بموظفين او ليس له اشتراك في المؤسسة العامة للتأمينات الاجتماعية اذا ليس عليك اضافته هنا.  ',
  completed_msg: 'تهانينا ، لقد أكملت بالفعل المرحلة الأولى من مرحلة التأسيس و تهيئة النظام. ',
  calendar: 'التقويم',
  configured_by_bank_file: ' الدفع عن طريق ملف البنك',
  carry_all_forward: 'ترحيل كامل الرصيد',
  carry_all_forward_description:
    'يمكن ترحيل كامل الرصيد المتبقي في نهاية السنة لرصيد السنة المقبلة.',
  calendar_days: 'أيام تقويمية',
  calendar_days_description:
    'احتساب جميع أيام الإجازة حتى لو تداخلت مع إجازة نهاية الأسبوع. (باستثناء إجازات الأعياد الرسمية)',
  customizing_leaves: 'الإجازات المخصصة',
  customizing_leaves_description:
    'يمكنك إضافة إجازات خاصة بحسب احتياجات الشركة وطبيعة عملها، يمكنك تحديد نوع الإجازة، عدد أيامها، وتفعيلها أو الغائها لاحقًا.',
  cutoff_day: 'تاريخ الإستقطاع',
  cutoff_day_desc:
    'وهو اليوم الذي يبدأ فيه تحضير وتجميع جميع المعاملات مثل سجلات الحضور والقروض والإجازات وما إلى ذلك من أجل إدراجها في كشوف المرتبات الخاصة بكفي العادة المعاملات التي تخص الفترة التي تبدأ بعد تاريخ الإستقطاع يتم ترحيلها واحتسابها ضمن الشهر التالي لذلك فإن أي معاملات تخص سجل الحضور والإنصراف مثل العمل الإضافي أو التغيب عن العمل والتي تخص الفترة التي تبدأ بعد تاريخ الإستقطاع سوف يتم إحتسابها ضمن مسير الرواتب للشهر التالي, أيضاً عند إنضمام موظف للفريق بعد تاريخ الإستقطاع فإنه سوف يتم تسليم راتبه في الشهر التالي.',
  congratulations_onboarding: 'تم!',
  check_email: 'تفقد بريدك الإلكتروني',
  create_password: 'تعيين كلمة المرور',
  confirm_title: 'هل قمت بإضافة حسابك أيضاً؟',
  confirm_msg:
    'نذكرك بإضافة حسابك كمستخدم مسؤول حتى نتمكن من إرسال البريد الإلكتروني الخاص بإعادة تعيين كلمة السر الخاصة لك لتسطيع استكمال باقي الخطوات.',
  confirm_but: 'حسابي مضاف',
  confirm_cancel: 'العودة للتعديل',
  company_name_en: 'Company Name (English)_AR',
  company_name_ar: 'Company Name (Arabic)_AR',
  commercial_registration: 'Add your Commercial Registration_AR',
  customized_settings: 'إعدادات مخصصة',
  customized_settings_title: 'تخصيص إعدادات الإجازات ومسير الرواتب',
  org_account_link: 'رابط حساب المنشأة',
  click_here_onboard: '[اضغط هنا]',
  // D
  des_for_name: 'اتبع الخطوات التالية لتنشيط حسابك:',
  des_login_to_jisr:
    'استخدم كلمة المرور الجديدة وبريدك الإلكتروني للولوج لنظام {{app_name}} والاستمتاع بخدماتنا',
  des_create_password: 'اضغط على الرابط لتعيين كلمة المرور الجديدة الخاصة بك',
  des_check_email: 'لقد أرسلنا رابط تعيين كلمة المرور إلى البريد الإلكتروني',
  download_uploaded_data: 'تحميل البيانات المرفوعة',
  download_faulty_records: 'حمل ملف الأخطاء',
  do_you_have_one_multi: 'هل لدى المنشأة سجل تجاري واحد او اكثر؟',
  define_custome_job_title: 'إضافة مسمى وظيفي مخصص',
  define_job_titles_description: 'تحديد المسميات الوظيفية لـ {{groups_name}}',
  define_assets_description: 'حدد كل أنواع العهد التي تريد إضافتها إلى {{groups_name}}',
  do_you_have_subsidiaries_description: 'هل يوجد منشآت فرعية تابعة لـ  ؟',
  download_sample_employee_data_file: 'تحميل ملف نموذج بيانات الموظفين الافتراضي',
  define_a_new_employment_type: 'تعريف نوع توظيف جديد',
  delete: 'حذف',
  done_finish: 'مكتمل',
  didnt_receive_otp: "Didn't receive OTP?:AR",
  disabled: 'معطل',
  define_business_units_desc:
    ' من فضلك ، حدد وحدات العمل الموجودة في مؤسستك. لذلك ، يمكنك بسهولة تعيين موظفين إلى وحدات معينة.',
  department_division_desc:
    'يمكنك هنا اضافة الادارات و الاقسام حسب الهيكل التنظيمي في المنشأة من خلال تعريف الادارات اولا ثم اضافة قسم واحد علي الاقل في كل ادارة. في خطوة لاحقة يمكنك اضافة موظفين في كل قسم و سوف يتم ربط الموظفين بالادارة التابع لها هذا القسم بشكل مباشر و لكن ',
  define_various_desc:
    'يمكنك إدخال أنواع توظيف متنوعة لتتمكن من ترتيب وإدارة التوظيف بأفضل شكل ممكن',
  Do_you_run_one: 'هل تدير منشأءة واحدة أو أكثر؟',
  download_leave_etails_sheet: 'تنزيل ملف تفاصيل الإجازة',
  download_salaries_details_sheet: 'حمل ملف قالب الرواتب',
  drag_and_drop_file_or: 'قم بسحب الملف وإفلاته أو،',
  drag_and_drop_file_or_browse_computer: 'قم بسحب الملف وإفلاته ، أو تصفح الكمبيوتر',
  drag_and_drop_files_or_browse_computer: 'قم بسحب الملفات وإفلاتها ، أو تصفح الكمبيوتر',
  dayse_per_year: 'أيام الإجازة المستحقة في السنة',
  default_settings: ' إعدادات افتراضية [متوافقة مع قانون العمل]',
  des_customized: 'تخصيص جميع السياسات والإعدادات في مرحلة التأسيس.',
  drag_and_drop: 'اسحب وأفلت الصورة او اضغط للبحث',
  delete_confirmation: 'تأكيد الحذف',
  // E
  edit_business_unit: 'تعديل وحدة العمل',
  admins_invitation: 'دعوة المشرفين',
  emp_id: 'الرقم الوظيفي',
  enter_cr_details: 'تفاصيل السجل التجاري ',
  enter_mol_details: 'تفاصيل مكتب العمل  ',
  edit: 'تعديل',
  enter: 'ENTER_AR',
  enter_gosi_number: ' رقم التأمينات الاجتماعية  ',
  enter_gosi_details: ' تفاصيل التأمينات الاجتماعية',
  enter_iban: 'إدخل رقم الحساب',
  enter_the_main_headquarter_desc:
    'أدخل عنوان المقر الرئيسي للمنشأة. ستتمكن لاحقًا من إضافة عناوين الفروع الأخرى. ',
  enter_leave_name: 'Enter Leave name AR',
  employment_type_discription: 'نوع التوظيف',
  employee_onboarding: 'الموظف',
  employee_payment_details: 'تفاصيل الموظف البنكية',
  employee_payment_details_desc:
    'After adding the allowances of your company, Now define the payment info of your employees:AR.',
  employees_data: 'بيانات الموظفين',
  exit: 'خروج',
  enable_employees_to_use_jisr_by_inviting_them:
    'اسمح للموظفين باستخدام {{app_name}} بعد دعوتهم للنظام',
  // F
  faulty_records_new_records_added: '{{faulty}} خطأ في المعلومات, {{added}} معلومات جديدة مضافة',
  file_processed: 'File Processed:AR',
  food_beverages: 'Food & BeveragesAR',
  finance_real_estate: 'Finance & Real EstateAR',
  for_outsource_employees: 'الاستعانة بعمالة خارجية',
  follow_the_labor_law_holidays: 'التماشي مع نظام العمل',
  full_balance: 'إتاحة كامل الرصيد',
  full_balance_description:
    'سيتاح كامل الرصيد الإجازات السنوية للموظفين من اليوم الأول وقبل استحقاقها.',
  full_balance_description_tip:
    'ملاحظة: قد يؤثر هذا الاختيار على المخالصة النهائية للموظف في حال انهاء خدمته بعد استخدامه لرصيد إجازات غير مستحق.',
  faster_setup: 'مختصرة',
  // G
  great_your_organisation_is_set_up: 'يعطيكم العافية! تم إعداد المنشأة بنجاح',
  gosi_files: 'ملفات التأمينات الاجتماعية',
  gosi_files_status: 'حالة ملفات التأمينات الاجتماعية',
  // H
  hello: 'HelloAR',
  help_center: 'مركز المساعدة',
  hospitality_hotels: 'Hospitality & HotelsAR',
  // I
  iban_onboarding: 'رقم الحساب المصرفي',
  industry_name_ar: 'اسم القطاع بالعربي',
  import_employee_data: 'رفع  بيانات الموظفين',
  industry: 'القطاع',
  invite_employees: 'دعوة الموظفين',
  invite_admins: 'دعوة المشرفين',
  invite_employees_description: `By enabling this option, whenever an employee returns from a leave, a confirmation request will be required from the employee.
  If you use {{app_name}} Attendance the request will be auto-generated once the employee clocks-in. Then it will be the manager's job to confirm the employee's return. Otherwise the employee will be recorded Absent.
  If you disable this option, employee’s attendance will be treated as usual after returning from leave.AR`,
  industry_name_en: 'اسم القطاع بالانجليزي',
  invite_admin_users: 'دعوة المشرفين',
  invite_all: 'دعوة كل المشرفين',
  invited: 'تم دعوتهم',
  invited_emp: 'الدعوة مرسلة',
  // J
  // K
  kindl_define_your_industry: 'يرجى تحديد قطاع المنشأة',
  kindly_ensure_to_add_the_email_description:
    'يرجى التأكد من إضافة البريد الإلكتروني للموظفين الذين ترغب في دعوتهم لتسجيل الدخول على الحساب في الخطوة التالية',
  // L
  labor_law_leaves_and_public_holidays: 'اجازات نظام العمل',
  let_us_know_more_about_your_organization: 'دعونا نبني الهيكل التنظيمي للمنشأة',
  Lets_import_your_employee_data: 'الخطوة التالية هي استيراد بيانات الموظفين',
  logo: 'الشعار',
  leave_config_done: 'أكملت إعداد الإجازات',
  leave_resumption_onboarding: 'Leave resumptionAR',
  leaves_setup: 'إعداد الاجازات',
  leave_name_onboardin: 'مسمى الإجازة باللغة الإنجليزية',
  leave_name_ar_onboardin: 'مسمى الاجازة باللغة العربية',
  labor_law_leaves: 'اجازات نظام العمل',
  labor_law_leaves_description:
    ' فعّلت إجازات نظام العمل السعودي تلقائيًا لمساعدتك في التماشي مع الأنظمة المحلية، ويمكنك تعديل تلك الإجازات بما يتوافق مع سياسة الشركة.',
  limited_carry_forward: 'ترحيل جزء من الرصيد',
  limited_carry_forward_description:
    'يمكن ترحيل جزء من الرصيد المتبقي في نهاية السنة لرصيد السنة المقبلة.',
  login_to_jisr: 'سجل دخولك إلى {{app_name}}',
  leaves_and_payroll_configurations: 'إعدادات الإجازات ومسير الرواتب',
  launch_account: 'Launch Account_AR',
  // M
  multi_crs: 'عدة سجلات تجارية',
  mudad_desc: 'مؤتمتة وسهلة الاستخدام, مربوطه مع البنوك ونظام حماية الأجور.',
  mudad_setup: 'إعداد الربط مع مدد',
  media_sdvertisement: 'Media & AdvertisementAR',
  mol_prefix_1_28: 'الأرقام البادئية لمكتب العمل',
  mol_number: 'رقم مكتب العمل ',
  mol_files: 'ملفات مكتب العمل',
  muqeem_files: 'ملفات مُقيم',
  mol_prefix: 'رقم مكتب العمل',
  make_this_main_work_location_for: 'تحديد كموقع العمل الأساسي لـ {{name}}',
  minimum_value: 'الحد الأدنى للرصيد',
  more_customized: 'مفصلة',
  // N
  no: 'لا',
  name_in_english_onboarding: 'الاسم باللغة الانجليزية',
  name_in_english: 'الاسم باللغة الانجليزية  ',
  name_in_arabic: 'الاسم باللغة العربية ',
  note_each_parent_department_should_description:
    'عليك فقط ان تتاكد انك اضفت علي الاقل قسم واحد داخل كل ادارة',
  mudad_cr_number: 'رقم السجل التجاري({{number}})',
  mudad_subscription: 'إشتراك مدد',
  note: 'ملاحظة',
  No_confirmation_is_needed: 'لا تطلب تأكيد العودة من الإجازة',
  No_confirmation_is_needed_description:
    'تأكيد العودة غير مطلوب، وسيسجل تاريخ عودة الموظف في أول يوم عمل بعد الإجازة.',
  next_onboardin: 'التالي',
  number_of_employees_use_bank: 'عدد الموظفين لديهم حسابات بنكية',
  number_of_employees_use_cash: 'عدد الموظفين نقداً',
  number_of_employees_use_cheque: 'عدد الموظفين يتم الدفع لهم عبر شيك',
  number_of_employees_use_international_transfer: 'عدد الموظفين يتم الدفع لهم عن طريق حوالة دولية',
  next_month_date: 'الشهر التالي({{date}})',
  // O
  offline_processing_desc: 'دفع الرواتب يدويا, عن طريق تحميل ملف البنك ورفعه للبنك',
  offline_setup: ' الدفع عن طريق ملف البنك',
  one_cr: 'سجل تجاري واحد',
  organization_details_onboarding: ' معلومات المنشأة',
  organization_name_en: 'إسم المنشأة باللغة الانجليزية',
  organization_name_ar: 'إسم المنشأة باللغة العربية (إختياري)',
  onboarding_mudad_otp_message:
    'We’ve sent an OTP to <b>{{name}}</b> mobile number ending with <b>{{number}}</b>. Please contact the and get the OTP to verify the user:AR.',
  onboarding_steps: 'خطوات إعداد معلومات المنشاءة الأساسية ',
  others: 'اخرى',
  organization: 'المنشأة',
  organization_type: 'نوع المنشأة',
  opening_balance: 'الرصيد الافتتاحي',
  organization_info_onboarding: 'المعلومات الأساسية',
  owner_verification_step: 'التحقق من المالك/الشخص المفوض',
  owner_verification_desc: 'يرجى إدخال هوية المالك أو المفوض بالمنشأة داخل المؤسسة',
  organization_logo: 'Organization Logo_AR',
  org_details_and_industry: 'الهيكل القانوني',
  org_structure_and_logo: 'تفاصيل المنشأة',
  onboarding_subdomain: 'What subdomain you would like to use for your account?_AR',
  // P
  primary_work_location: 'موقع العمل الأساسي',
  Please_upload_mol_muqeem_and_gosl_files_for_your_crs:
    'من فضلك قم برفع الملفات التالية: مقيم و ملف مكتب العمل (MOL)',
  press: 'press_AR',
  press_ENTER: 'انقر على زر ENTER',
  please_import_the_employee_data_file_after_you_fill_it: 'يرجى رفع ملف بيانات الموظف بعد تعبئته.',
  pay_day: 'تاريخ الدفع',
  payroll_preferences_are_all_set: 'تم إكمال جميع إعدادات مسير الرواتب المطلوبة',
  payment_file: 'Payment file:AR',
  payment_methods_desc:
    'استخدامك لمدد سيمكنك من دفع الرواتب وربطها بنظام حماية الأجور مباشرةً من {{app_name}}. أما طريقة الدفع عن طريق ملف البنك ستتطلب معالجة عملية دفع الرواتب يدويًا بعد تصدير ملف الرواتب.',
  payroll_bank: 'بنك الرواتب',
  payroll_bank_desc:
    'سيتم استخدام الحساب المصرفي لكل سجل تجاري (منشأة) لتحويل رواتب الموظفين. الرجاء إضافة حساب مصرفي لكل سجل تجاري',
  pay_schedules: 'جدولة مسير الرواتب',
  pay_schedules_desc:
    ' تحديد يوم الاستقطاع وشهر استخدام المسير سيحدد آلية التعامل والاحتساب لمسير الرواتب لكل شهر',
  payroll_month_desc:
    'هل تريد البدء بمسير الرواتب على {{app_name}} في هذا الشهر أو في الشهر التالي؟',
  payroll_payment_file: 'Payroll payment file:AR',
  payroll_payment_file_desc:
    'Upload the last payroll bank file, so {{app_name}} can extract all payment information for your employees:AR.',
  payroll_setup: 'تهيئة مسير الرواتب',
  payroll_setup_desc:
    'ارفع رواتب الموظفين والبدلات، وحدد يوم الاستقطاع، واختر طريقة دفع الرواتب المناسبة لك',
  public_holidays: 'العطلات الرسمية',
  public_holidays_description:
    ' تختلف الأعياد الرسمية عن الإجازات السابقة بكونها محصورة في تاريخ محدد لجميع الموظفين وتستحق في تلك المدة فقط. فلا يمكن للموظف تقديمها أو تأخيرها الا بالتنسيق مع جهة العمل.',
  public_holidays_tip:
    'ملاحظة: يحدد نظام العمل الحد الأدنى لهذه الإجازات ويستحق كل موظف إجازة مدفوعة في هذه الفترة. إذا اقتضت طبيعة العمل الحضور في هذه الأيام، تعوّض الشركة الموظف بالطرق المناسبة.',
  preferred_settings:
    'هذه الخيارات ستحدد عدد الخطوات المطلوبة في مرحلة التأسيس، ويمكنك تعديل جميع البنود لاحقًا.',
  // Q
  // R
  remove: 'إزالة',
  retail: 'Retail',
  review: 'مراجعة',
  review_employees_data: 'مراجعة رواتب الموظفين',
  review_employees_data_desc:
    'رواتب الموظفين في الجدول أدناه هي ما سيظهر في مسير الرواتب وملف الموظف على {{app_name}}  يمكنك مراجعتها وتعديلها الآن أو بعد تفعيل الحساب.',
  review_employees_payment: 'طريقة استلام الراتب',
  review_employees_payment_desc:
    'أدناه طريقة تسليم الراتب لكل موظف، يمكنك مراجعة كافة البيانات والتعديل عليها',
  reviewing_employee_data: 'مراجعة بيانات الموظفين',
  review_page: 'مراجعة البيانات',
  review_page_description:
    'سترفع البيانات على {{app_name}} مطابقةً للتفاصيل الموضحة أدناه. يمكنك مراجعة كافة المعلومات قبل تأكيد الرفع.',
  remaining_balance_onboarding: 'الرصيد المتبقي',
  remaining_balance_settings: 'الرصيد المتبقي',
  remaining_balance_settings_description:
    'يمكنك تحديد طريقة التعامل مع الرصيد المتبقي في حال انهاء الموظف للسنة دون استخدام كامل الرصيد',
  remaining_balance_settings_description_tip:
    'معلومة: يجب على الموظف أخذ الإجازة خلال السنة. في حال امتناع الشركة عن خروجه، فقد يعد تصفير رصيد الاجازة غير قانوني، ويفضل مراجعته من قبل المختصين في نظام العمل.',
  resend: 'Resend:AR',
  reset_balance: 'تصفير الرصيد',
  reset_balance_description: 'لا يمكن ترحيل الرصيد للسنة المقبلة.',
  return_confirmation: 'تأكيد العودة من الإجازة',
  return_confirmation_description:
    'تساعدك هذه الخاصية في التأكد من عودة الموظف من الإجازة السنوية، رصد الحضور لا يتأثر بهذا الاختيار وستحفظ جميع سجلات الموظف في كل الأحوال.',
  return_confirmation_description_tip:
    'إذا كنت تستخدم نظام الحضور والانصراف المقدم من {{app_name}}، سينشأ طلب تأكيد العودة من الإجازة تلقائيا فور تسجيل بصمة الموظف (سواءً من الجهاز او الجوال). وسيكون الطلب في إنتظار موافقة المسؤول لتأكيد عودة الموظف، وسيعد الموظف غائبًا في حال عدم تأكيده للعودة.',
  require_Return_Confirmation_after_leave: 'طلب تأكيد العودة إلزامي',
  require_Return_Confirmation_after_leave_description:
    'يطلب من جميع الموظفين تأكيد عودتهم بعد الإجازة. في حال طلب الموظف لراتب الإجازة مقدمًا، لن يظهر الموظف في مسير الرواتب إلا بعد تأكيد عودته من الإجازة.',
  review_search_placeholder: 'رقم الموظف ,الاسم , المسمى الوظيفي',
  // S
  submit_merge: 'Submit & Merge:AR',
  search_employees_by_id_or_name: 'ابحث عن الموظفين اما بالاسم او عن طريق الرقم الوظيفي',
  save: 'حفظ',
  salary_setup: 'رواتب الموظفين',
  salaries_packages: 'رواتب الموظفين',
  salaries_packages_desc: 'بعد تحديد قائمة البدلات الخاصة بمنشأتك ، قم بتعريف الرواتب للموظفين',
  salary_card_no: 'رقم بطاقة الرواتب',
  skip: 'تخطي',
  setup_your_main_organization: 'إعدادت المنشأة',
  something_went_wrong_description: 'حدث خطأ أثناء رفع الشعار. فضلًا، حاول مرة أخرى',
  software: 'SoftwareAR',
  subdomain: 'النطاق الفرعي',
  subdomain_name: 'اسم رابط الدخول',
  summary_review: 'المراجعة',
  summary_review_desc:
    'في هذه الخطوة ، تأكد من صحة جميع البيانات. يمكنك دائمًا الرجوع وتعديل أي معلومة.',
  select_your_preffered_language_it_will_be_used_throughout_this_wizard:
    'اختر لغة الإعداد التي تناسبك. سيتم استخدام هذه اللغة خلال عملية الإعداد، ويمكنك التحكم في لغة النظام لاحقًا',
  language_selection: 'اختيار اللغة',
  setting_up_your_organization: 'إنشاء منظمتك',
  select_bank: 'Select Bank:AR',
  select_cutoff_date: 'اختر تاريخ الاستقطاع',
  select_the_field_desc: 'اختر قطاع أو مجال المنشأة المناسب لك',
  set_annual_leave_policy:
    'حدد سياسة الإجازات السنوية، اجازات نظام العمل، وأرصدة الإجازات للموظفين',
  select_holidays: 'حدد الاعياد',
  starting_balance: ' آلية إتاحة الرصيد',
  starting_balance_description:
    'يمكنك اختيار طريقة إتاحة رصيد الإجازة السنوية للموظفين، والاختيار ما بين اتاحة كامل الرصيد أو الإتاحة التراكمية',
  start: 'بدء',
  start_command: 'أبدا',
  select_payment_method: 'إختر طريقة الدفع',
  saudi_labor_title: 'تطبيق الإعدادات الافتراضية',
  saudi_labor_des:
    'ستطبق جميع الإعدادات الافتراضية المتوافقة مع نظام العمل السعودي. ولن تحذف الخيارات المخصصة المضافة مثل أنواع الإجازات أو البدلات.',
  saudi_labor_law: 'تطبيق إعدادات {{app_name}} الافتراضية',
  select_users:
    'Select users to give admin permissions to your {{app_name}} account, this will give them full access to all employees data and system settings._AR',
  // T
  this_configuration_desc:
    'يمكنك اختيار طريقة احتساب راتب الإجازة, اما على أساس الراتب الأساسي, أو على أساس مجموع الراتب, أو على أساس الراتب الأساسي ومجموعة من البدلات التي يمكن تحديدها',
  this_subdomain_is_taken: 'للأسف، اسم النطاق مأخوذ بالفعل',
  this_month_date: 'الشهر الحالي ({{date}})',
  the_cutoff_date: 'The Cut-off Date:AR',
  the_selected_bank_for_the_payroll: 'The selected bank for the payroll:AR',
  cutoff_date: 'تاريخ الإستقطاع',
  cutoff_date_desc:
    'عند تحديد يوم الاستقطاع, سيكون احتساب مسيّر الرواتب على الفترة ما بين أيام الاستقطاع من كل شهر، ويشمل ذلك المعاملات المالية وسجلات الحضور والانصراف ومايترتب عليها  ',
  technology: 'TechnologyAR',
  types: 'البدلات',
  // U
  upload_Savola_Groups_Logo: 'الآن تحتاج إلى رفع شعار {{groups_name}} المميز',
  update_bulk_employees_salaries: 'تعديل رواتب الموظفين عن طريق القالب',
  upload_govt_files: 'رفع الملفات الحكومية',
  upload_employee_data: 'رفع بيانات الموظفين',
  usually_has_the_following_job_titles: '{{name}}, عادة ما تحتوي على المسميات الوظيفية التالية',
  usually_has_the_following_job_assets: 'ترشيحات لبعض انواع العهد الشائع استخدامها',
  up_to_which_date: 'تاريخ انتهاء الرصيد',
  user_role: 'دور المستخدم',
  use_the_labor_low_leaves: 'تفعيل الإجازات المقترحة من مكتب العمل',
  update_custom_leave_onboarding: 'تعديل اجازة مخصصة',
  update_add_holidays_leave: 'تعديل عيد رسمي',
  upload_annual_leave_files: 'رفع بيانات الإجازة السنوية',
  upload_annual_leave_files_discription: `لرفع البيانات الحالية للموظفين على نظام {{appName}}، اتبع الخطوات التالية:
  <br />1- حمّل ملف تفاصيل الإجازات.
  <br />2- عبّئ بيانات الموظفين كما هو موضح في الملف
  <br />3- ارفع الملف على نظام {{appName}}.`,
  upload_employees_salaries_data_desc: `لتحميل بيانات رواتب الموظفين على {{app_name}}:
  <br />1- قم بتحميل ملف قالب الرواتب الخاص ب{{app_name}}
  <br />2- املأ الملف بتفاصيل رواتب الموظفين
  <br />3- قم برفع الملف`,
  // V
  verify_employees_desc:
    'حدد الموظفين المصرح لهم بمعالجة دفع الرواتب من خلال البنك الذي تتعامل معه.',
  verify_otp: 'Verify OTP:AR',
  verify_payment_admins: 'التحقق من مسئولي عملية الدفع',
  verify_payment_admins_step: 'التحقق من مسئولين عملية الدفع',
  view_more: 'عرض المزيد',
  view_the_applied_settings:
    'يمكنك تعديل جميع الإعدادات الافتراضية لاحقًا، لعرض الإعدادات التي ستطبق على حساب المؤسسة',
  // W
  which_medical_insurance: 'ما هي شركة التأمين الطبي التي تتعامل معها في مؤسستك؟',
  which_accounting_system: 'ما هو البرنامج المحاسبي الذي تعتمد عليه مؤسستك؟',
  which_pos_system: 'ما هو نظام نقطة البيع الذي تستخدمة في مؤسستك؟',
  what_is_the_other_company: 'ما هي الشركة الأخرى التي تستخدمها؟',
  work_location: 'موقع العمل ',
  wizard_language: 'لغة الإعداد',
  whats_your_preferred_language: 'فضلًا اختر اللغة ',
  whats_the_name_of_your_organization: 'ما اسم المنشأة؟',
  work_locations_for_savola_groups: 'قائمة مواقع العمل لـ ()',
  what_industries_Savola_description: 'ما هو قطاع {{name}}',
  what_subdomain_would_description:
    'ما هو اسم رابط الدخول الذي تود استخدامة للدخول الي منصة {{app_name}}؟',
  what_employment_types_you_have: 'ما أنواع العقود لديكم؟',
  whats_the_name_of_outsource_provider_description:
    'ما هو اسم مزود خدمة التعهيد/الاستعانة بمصادر خارجية لموظفي أجير؟',
  welcome_dear_name_to_jisr: 'أهلًا بك عزيزي {{name}}',
  we_ve_created_a_sample_employee_data_description:
    'لقد أنشأنا نموذجًا لبيانات الموظفين بناءً على الاختيار الذي حددته حتى الآن. قم بتنزيله وتحميله مرة أخرى بعد التحرير حسب احتياجاتك.',
  work_locations: 'مواقع العمل و الفروع',
  will_do_it_later: 'سأفعل ذلك لاحقًا',
  would_you_like_to_delete_description: 'هل ترغب في حذف الموظف الذي تم تحديده؟',
  would_you_like_to_delete_employees_description: 'هل ترغب في حذف الموظفين الذين تم تحديدهم؟',
  // X
  // Y
  yes: 'نعم',
  youre_good_to_go: 'رائع! يمكنك استخدام هذا النطاق',
  You_ve_successfully_uploaded_the_employee_data_description:
    'تم رفع بيانات الموظفين بنجاح. يمكنك الآن مراجعتها.',
  // Z
}

export default onboarding
